export const applicationConstants = {
  TOGGLE__SIDEBAR_MENU: 'TOGGLE__SIDEBAR_MENU',
};
